"use client"

import { useState, useCallback } from "react"
import { usePCBStore } from "@/hooks/use-pcb-store"
import { TopToolbar } from "@/components/top-toolbar"
import { PCBCanvas } from "@/components/pcb-canvas"
import { LayersPanel } from "@/components/layers-panel"
import { StatusBar } from "@/components/status-bar"

export default function PCBReverseTool() {
  const store = usePCBStore()
  const [selectedNet, setSelectedNet] = useState<string | null>(null)
  const [blinkingNet, setBlinkingNet] = useState<string | null>(null)

  // Handle double-click on net to trigger blinking effect
  const handleNetDoubleClick = useCallback((net: string) => {
    setBlinkingNet(net)
    // Stop blinking after 2 seconds
    setTimeout(() => {
      setBlinkingNet(null)
    }, 2000)
  }, [])

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      {/* Top Toolbar */}
      <TopToolbar store={store} />

      {/* Main content area */}
      <div className="flex flex-1 overflow-hidden">
        {/* Canvas area */}
        <PCBCanvas store={store} selectedNet={selectedNet} blinkingNet={blinkingNet} />

        {/* Layers panel (right sidebar) */}
        <div className="w-64 shrink-0">
          <LayersPanel store={store} selectedNet={selectedNet} onSelectNet={setSelectedNet} onNetDoubleClick={handleNetDoubleClick} />
        </div>
      </div>

      {/* Status bar */}
      <StatusBar store={store} />
    </div>
  )
}
